import React, { useEffect, useState } from 'react';
import api from '../services/api';

const ESTADOS: Record<string, { color: string; bg: string; label: string }> = {
  activo:     { color: '#22c55e', bg: '#22c55e22', label: 'Activo' },
  completado: { color: '#38bdf8', bg: '#38bdf822', label: 'Completado' },
  cancelado:  { color: '#ef4444', bg: '#ef444422', label: 'Cancelado' },
};

const PlanesPago: React.FC = () => {
  const [planes, setPlanes] = useState<any[]>([]);
  const [clientes, setClientes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modalNuevo, setModalNuevo] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [form, setForm] = useState({
    clienteId: '',
    montoTotal: '',
    montoCuota: '',
    numeroCuotas: '',
    fechaInicio: new Date().toISOString().slice(0, 10),
    notas: '',
  });
  const [busqueda, setBusqueda] = useState('');

  const cargar = async () => {
    setLoading(true);
    try {
      const [pRes, cRes] = await Promise.all([api.get('/planes-pago'), api.get('/clientes')]);
      setPlanes(pRes.data);
      setClientes(cRes.data);
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const clienteNombre = (id: string) => {
    const c = clientes.find(c => c.id === id);
    return c ? `${c.nombres} ${c.apellidos}` : id;
  };

  const guardar = async () => {
    if (!form.clienteId || !form.montoTotal || !form.montoCuota || !form.numeroCuotas) {
      alert('Completa todos los campos obligatorios');
      return;
    }
    setGuardando(true);
    try {
      await api.post('/planes-pago', {
        ...form,
        montoTotal: Number(form.montoTotal),
        montoCuota: Number(form.montoCuota),
        numeroCuotas: Number(form.numeroCuotas),
      });
      setModalNuevo(false);
      setForm({ clienteId: '', montoTotal: '', montoCuota: '', numeroCuotas: '', fechaInicio: new Date().toISOString().slice(0, 10), notas: '' });
      cargar();
    } catch (e: any) { alert(e?.response?.data?.message || 'Error al guardar'); }
    finally { setGuardando(false); }
  };

  const registrarCuota = async (id: string) => {
    try {
      await api.put(`/planes-pago/${id}/cuota`);
      cargar();
    } catch (e: any) { alert(e?.response?.data?.message || 'Error'); }
  };

  const cancelar = async (id: string) => {
    if (!window.confirm('¿Cancelar este plan de pago?')) return;
    try {
      await api.put(`/planes-pago/${id}/cancelar`);
      cargar();
    } catch {}
  };

  const clientesFiltrados = clientes.filter(c =>
    `${c.nombres} ${c.apellidos} ${c.dni}`.toLowerCase().includes(busqueda.toLowerCase())
  );

  const planesActivos = planes.filter(p => p.estado === 'activo').length;
  const planesCompletados = planes.filter(p => p.estado === 'completado').length;

  return (
    <div>
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h2 style={{ color: '#f1f5f9', margin: 0, fontSize: 24, fontWeight: 800 }}>💳 Planes de Pago</h2>
          <p style={{ color: '#64748b', margin: '4px 0 0', fontSize: 13 }}>Acuerdos de cuotas para clientes morosos</p>
        </div>
        <button onClick={() => setModalNuevo(true)}
          style={{ background: '#0ea5e9', border: 'none', color: 'white', borderRadius: 10, padding: '10px 20px', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
          + Nuevo plan
        </button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 24 }}>
        {[
          { label: 'Total planes', value: planes.length, color: '#38bdf8' },
          { label: 'Activos', value: planesActivos, color: '#22c55e' },
          { label: 'Completados', value: planesCompletados, color: '#a78bfa' },
        ].map(s => (
          <div key={s.label} style={{ background: '#1e293b', borderRadius: 12, padding: '16px 20px', border: '1px solid #334155' }}>
            <div style={{ color: '#64748b', fontSize: 12, fontWeight: 600, marginBottom: 4 }}>{s.label}</div>
            <div style={{ color: s.color, fontSize: 28, fontWeight: 800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Tabla planes */}
      <div style={{ background: '#1e293b', borderRadius: 16, border: '1px solid #334155', overflow: 'hidden' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #334155' }}>
          <span style={{ color: '#f1f5f9', fontWeight: 700 }}>Planes registrados</span>
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 32, color: '#64748b' }}>Cargando...</div>
        ) : planes.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#64748b' }}>Sin planes de pago registrados</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#0f172a' }}>
                {['Cliente', 'Monto total', 'Cuota', 'Progreso', 'Inicio', 'Estado', 'Acciones'].map(h => (
                  <th key={h} style={{ padding: '10px 16px', color: '#64748b', fontSize: 12, fontWeight: 600, textAlign: 'left' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {planes.map(p => {
                const est = ESTADOS[p.estado] || ESTADOS.activo;
                const pct = Math.round((p.cuotasPagadas / p.numeroCuotas) * 100);
                return (
                  <tr key={p.id} style={{ borderBottom: '1px solid #0f172a' }}>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ color: '#f1f5f9', fontWeight: 600 }}>{clienteNombre(p.clienteId)}</div>
                      {p.notas && <div style={{ color: '#64748b', fontSize: 11, marginTop: 2 }}>{p.notas}</div>}
                    </td>
                    <td style={{ padding: '12px 16px', color: '#f1f5f9', fontWeight: 700 }}>S/. {Number(p.montoTotal).toFixed(2)}</td>
                    <td style={{ padding: '12px 16px', color: '#94a3b8', fontSize: 13 }}>S/. {Number(p.montoCuota).toFixed(2)}</td>
                    <td style={{ padding: '12px 16px', minWidth: 140 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{ flex: 1, background: '#0f172a', borderRadius: 4, height: 8, overflow: 'hidden' }}>
                          <div style={{ width: `${pct}%`, background: pct >= 100 ? '#22c55e' : '#0ea5e9', height: '100%', borderRadius: 4 }} />
                        </div>
                        <span style={{ color: '#94a3b8', fontSize: 11, whiteSpace: 'nowrap' }}>
                          {p.cuotasPagadas}/{p.numeroCuotas}
                        </span>
                      </div>
                    </td>
                    <td style={{ padding: '12px 16px', color: '#94a3b8', fontSize: 12 }}>{p.fechaInicio}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ background: est.bg, color: est.color, borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700 }}>
                        {est.label}
                      </span>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {p.estado === 'activo' && (
                          <>
                            <button onClick={() => registrarCuota(p.id)}
                              style={{ background: '#22c55e22', border: '1px solid #22c55e44', color: '#22c55e', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                              + Cuota
                            </button>
                            <button onClick={() => cancelar(p.id)}
                              style={{ background: '#ef444422', border: '1px solid #ef444444', color: '#ef4444', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                              Cancelar
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal nuevo plan */}
      {modalNuevo && (
        <div style={{ position: 'fixed', inset: 0, background: '#00000088', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div style={{ background: '#1e293b', borderRadius: 16, padding: 28, width: 480, border: '1px solid #334155', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 18, marginBottom: 20 }}>Nuevo plan de pago</div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4 }}>Cliente *</label>
              <input value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="Buscar cliente..."
                style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: 'white', fontSize: 13, boxSizing: 'border-box' as any, marginBottom: 6 }} />
              <select value={form.clienteId} onChange={e => setForm({ ...form, clienteId: e.target.value })}
                style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: 'white', fontSize: 13, boxSizing: 'border-box' as any }}>
                <option value="">Seleccionar cliente</option>
                {clientesFiltrados.slice(0, 50).map(c => (
                  <option key={c.id} value={c.id}>{c.nombres} {c.apellidos} — {c.dni}</option>
                ))}
              </select>
            </div>

            {[
              { label: 'Monto total (S/.)', key: 'montoTotal', type: 'number', placeholder: '0.00' },
              { label: 'Monto por cuota (S/.)', key: 'montoCuota', type: 'number', placeholder: '0.00' },
              { label: 'Número de cuotas', key: 'numeroCuotas', type: 'number', placeholder: '3' },
              { label: 'Fecha de inicio', key: 'fechaInicio', type: 'date', placeholder: '' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 14 }}>
                <label style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4 }}>{f.label}</label>
                <input type={f.type} value={(form as any)[f.key]} placeholder={f.placeholder}
                  onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                  style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: 'white', fontSize: 13, boxSizing: 'border-box' as any }} />
              </div>
            ))}

            <div style={{ marginBottom: 20 }}>
              <label style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4 }}>Notas</label>
              <textarea value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })}
                placeholder="Acuerdo, observaciones..."
                rows={3}
                style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: 'white', fontSize: 13, boxSizing: 'border-box' as any, resize: 'vertical' }} />
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={guardar} disabled={guardando}
                style={{ flex: 1, background: '#0ea5e9', border: 'none', color: 'white', borderRadius: 8, padding: '11px', cursor: 'pointer', fontWeight: 700, opacity: guardando ? 0.7 : 1 }}>
                {guardando ? 'Guardando...' : 'Crear plan'}
              </button>
              <button onClick={() => setModalNuevo(false)}
                style={{ background: '#334155', border: 'none', color: '#94a3b8', borderRadius: 8, padding: '11px 18px', cursor: 'pointer' }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanesPago;
